const root = document.documentElement;
root.classList.add('vendmont-js');

try {
  const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  let revealObserver;

  const registerRevealItems = (scope = document) => {
    const items = [];
    if (scope instanceof Element && scope.matches('[data-vendmont-reveal]')) items.push(scope);
    items.push(...scope.querySelectorAll('[data-vendmont-reveal]'));

    items.forEach((item) => {
      if (motionQuery.matches || !revealObserver) {
        item.classList.add('is-visible');
      } else {
        revealObserver.observe(item);
      }
    });
  };

  if (!motionQuery.matches && 'IntersectionObserver' in window) {
    revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );
  }

  registerRevealItems();

  const mutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) registerRevealItems(node);
      });
    });
  });
  mutationObserver.observe(document.documentElement, { childList: true, subtree: true });

  if (!motionQuery.matches) {
    root.classList.add('vendmont-motion');

    const depthItems = [
      ...document.querySelectorAll(
        '.vendmont-hero__content, .vendmont-hero__visual, .vendmont-zones__header, .vendmont-featured__header, .vendmont-newsletter__content'
      ),
    ];

    depthItems.forEach((item, index) => {
      item.dataset.vendmontDepth = '';
      item.dataset.vendmontDepthRate = String(index % 2 === 0 ? 0.045 : -0.035);
    });

    const tiltItems = [
      ...document.querySelectorAll(
        '.vendmont-hero__panel, .vendmont-zone-card, .vendmont-product-card, .vendmont-trust__item, .vm-card, .vm-service-card'
      ),
    ];

    tiltItems.forEach((item) => {
      item.dataset.vendmontTilt = '';

      item.addEventListener('pointermove', (event) => {
        if (event.pointerType === 'touch') return;
        const rect = item.getBoundingClientRect();
        const x = Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width));
        const y = Math.max(0, Math.min(1, (event.clientY - rect.top) / rect.height));

        item.style.setProperty('--vendmont-tilt-x', `${(0.5 - y) * 7}deg`);
        item.style.setProperty('--vendmont-tilt-y', `${(x - 0.5) * 9}deg`);
        item.style.setProperty('--vendmont-glow-x', `${x * 100}%`);
        item.style.setProperty('--vendmont-glow-y', `${y * 100}%`);
        item.classList.add('is-tilting');
      });

      item.addEventListener('pointerleave', () => {
        item.style.setProperty('--vendmont-tilt-x', '0deg');
        item.style.setProperty('--vendmont-tilt-y', '0deg');
        item.classList.remove('is-tilting');
      });
    });

    let depthFrame;
    const renderDepth = () => {
      depthFrame = undefined;
      const viewportCenter = window.innerHeight / 2;

      document.querySelectorAll('[data-vendmont-depth]').forEach((item) => {
        const rect = item.getBoundingClientRect();
        const distance = rect.top + rect.height / 2 - viewportCenter;
        const rate = Number(item.dataset.vendmontDepthRate || 0.035);
        const offset = Math.max(-24, Math.min(24, distance * rate));
        item.style.setProperty('--vendmont-depth', `${offset.toFixed(2)}px`);
      });
    };

    const requestDepth = () => {
      if (depthFrame) return;
      depthFrame = window.requestAnimationFrame(renderDepth);
    };

    const scrollRoot = document.querySelector('.page-wrapper') || window;
    scrollRoot.addEventListener('scroll', requestDepth, { passive: true });
    window.addEventListener('resize', requestDepth, { passive: true });
    requestDepth();
  }

  root.dataset.vendmontReady = 'true';
} catch {
  root.classList.remove('vendmont-js');
  document.querySelectorAll('[data-vendmont-reveal]').forEach((item) => item.classList.add('is-visible'));
}
